import {WebCallService} from "@/utilities/system/services/WebCallService";
import {PathHelper} from "@/utilities/system/helpers/PathHelper";
import {ErrorLocationType, HttpType} from "@/utilities/system/enums/Enums";
import ErrorHandler from "@/utilities/system/helpers/ErrorHandler";
import {GlobalSetting} from "@/models/entities/settings/GlobalSetting";
import { EditGlobalSettingRequest } from "@/models/api/requests";
import { ResponseValidator } from "@/utilities/system/helpers/ResponseValidator";

export class SettingsService {
    private webCaller: WebCallService;
    private uriHelper: PathHelper;
    private responseValidator: ResponseValidator;

    constructor(){
        this.webCaller = new WebCallService();
        this.uriHelper = new PathHelper();
        this.responseValidator = new ResponseValidator();
    }

    public async getGlobalSettings(errorLocationType:ErrorLocationType):Promise<Array<GlobalSetting>|null> {
        const uri = this.uriHelper.settings.getGlobalSettingsPath();

        const resp = await this.webCaller.HttpSend(HttpType.get, uri);
        if (!this.responseValidator.ValidateResponse(resp)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async editGlobalSetting(setting:GlobalSetting, errorLocationType:ErrorLocationType):Promise<GlobalSetting|null> {
        const uri = this.uriHelper.settings.getUpdateGlobalSettingsPath(setting.id);

        const requestBody = new EditGlobalSettingRequest(setting);

        const resp = await this.webCaller.HttpSend(HttpType.put, uri, requestBody);
        if (!this.responseValidator.ValidateResponse(resp)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }
}